import { EDIT_MODAL, GET_PROFILE } from 'redux/actions/types';

const initialState = {};

const usersReducer = (state = initialState, { type, res }) => {
  switch (type) {
    case GET_PROFILE:
      return {
        ...state,
        selectedUser: res,
      };
    case EDIT_MODAL:
      return {
        ...state,
        selectedUser: {
          ...state.selectedUser,
          editModal: !state.selectedUser.editModal,
        },
      };
    default:
      return state;
  }
};

export default usersReducer;
